import { AodRule } from '@app/modules/audit/modules/aod/aod.types';
import { useAuditReportsReplaceAodRulesById } from '@mi-front/api-v2';
import { useRouter } from '@mi-front/core';
import { useToast } from '@app/core/notifications';
import SaveIcon from '@mui/icons-material/Save';
import { Box, Button } from '@mui/material';
import { useIntl } from 'react-intl';
import { useWizardWithData } from '../../../../../../../core/hooks/WizardWithData';
import { aodRoutes } from '../../../routing/routes';
import { useAodFactory } from '../../aod-rules-add/custom/AodFactory';
import { AodRuleWizardValues } from '../../aod-rules-add/types';

interface AodRuleEditUpdaterProps {
  rule: AodRule;
}

export function AodRuleUpdater({ rule }: AodRuleEditUpdaterProps) {
  const { formatMessage } = useIntl();
  const { notifySuccess, notifyError } = useToast();
  const { data, previousStep } = useWizardWithData<AodRuleWizardValues<any, any, any>>();
  const { history } = useRouter();
  const updateRuleMutation = useAuditReportsReplaceAodRulesById();
  const { valuesToApi: convertToApi } = useAodFactory(data?.basic.reportType);

  const handleUpdateRule = async () => {
    try {
      await updateRuleMutation.mutateAsync({
        id: rule.id,
        data: convertToApi(data),
      });

      notifySuccess(
        formatMessage({
          id: 'audit.aod.rules.notifications.updated',
          defaultMessage: 'Regla AOD actualizada',
        }),
      );

      history.push(aodRoutes.ruleView.gen(rule.id));
    } catch (error) {
      notifyError(
        formatMessage({
          id: 'audit.aod.rules.notifications.updateError',
          defaultMessage: 'Error al actualizar la regla AOD',
        }),
      );
      console.error('Error updating AOD Rule:', error);
    }
  };

  return (
    <Box mt={3}>
      <Box>
        <Button
          onClick={handleUpdateRule}
          loading={updateRuleMutation.isPending}
          variant="outlined"
          color="primary"
          startIcon={<SaveIcon />}
          size="large"
        >
          {formatMessage({
            id: 'audit.aod.rules.edit.updateBtn',
            defaultMessage: 'Actualizar regla',
          })}
        </Button>
      </Box>
      <Box mt={2}>
        <Button
          color="warning"
          onClick={previousStep}
          variant="outlined"
          sx={{ mr: 1 }}
          disabled={updateRuleMutation.isPending}
        >
          {formatMessage({
            id: 'common.actions.back',
            defaultMessage: 'Atrás',
          })}
        </Button>
      </Box>
    </Box>
  );
}
